import React, { useEffect } from 'react';
import { useGameStore, useRoomStore } from '@store/index';
import { useSocket } from '@hooks/useSocket';
import { socketService } from '@services/SocketService';

export const DebugSocket: React.FC = () => {
  const gameState = useGameStore((state) => state.gameState);
  const roomCode = useRoomStore((state) => state.roomCode);
  const opponent = useRoomStore((state) => state.opponent);
  const playerColor = useRoomStore((state) => state.playerColor);
  
  // Use the socket hook to ensure events are registered
  useSocket();
  
  useEffect(() => {
    // Add debug listeners
    const handleConnected = () => {
      console.log('[DEBUG] Socket connected');
    };
    
    const handleDisconnected = (reason: any) => {
      console.log('[DEBUG] Socket disconnected:', reason);
    };
    
    const handleGameStarted = (data: any) => {
      console.log('[DEBUG] gameStarted event received:', data);
    };
    
    const handlePlayerJoined = (data: any) => {
      console.log('[DEBUG] playerJoined event received:', data);
    };
    
    socketService.on('connected', handleConnected);
    socketService.on('disconnected', handleDisconnected);
    socketService.on('gameStarted', handleGameStarted);
    socketService.on('playerJoined', handlePlayerJoined);
    
    // Check current connection status
    console.log('[DEBUG] Socket connected?', socketService.isConnected());
    console.log('[DEBUG] Socket ID:', socketService.getSocketId());
    
    return () => {
      socketService.off('connected', handleConnected);
      socketService.off('disconnected', handleDisconnected);
      socketService.off('gameStarted', handleGameStarted);
      socketService.off('playerJoined', handlePlayerJoined);
    };
  }, []);
  
  return (
    <div style={{ padding: '20px', background: '#f0f0f0', margin: '20px' }}>
      <h3>Socket Debug Info</h3>
      <p>Connected: {socketService.isConnected() ? 'Yes' : 'No'}</p>
      <p>Socket ID: {socketService.getSocketId() || 'Not connected'}</p>
      <p>Room Code: {roomCode || 'None'}</p>
      <p>Player Color: {playerColor || 'None'}</p>
      <p>Opponent: {opponent ? opponent.name : 'None'}</p>
      <p>Game State: {gameState ? `Status: ${gameState.gameStatus}` : 'No game state'}</p>
      <p>Current Turn: {gameState?.currentTurn || 'N/A'}</p>
      <p>Board: {gameState?.board ? 'Loaded' : 'Not loaded'}</p>
    </div>
  );
};